import { useAuth } from '@/context'

interface LicenseWithSubscriptionEnd {
	subscription_end?: string | null
	is_locked?: boolean
}

function isLicenseWithSubscriptionEnd(license: unknown): license is LicenseWithSubscriptionEnd {
	return license !== null && typeof license === 'object'
}

export function GracePeriodBanner() {
	const { user } = useAuth()

	const license = user?.license && isLicenseWithSubscriptionEnd(user.license) ? user.license : null
	const isLocked = license?.is_locked === true
	const subscriptionEnd =
		typeof license?.subscription_end === 'string' ? license.subscription_end : null
	// Show when subscription has ended (non-permanent with past subscription_end) and not locked
	const isSubscriptionExpired = subscriptionEnd !== null && new Date(subscriptionEnd) < new Date()

	if (!isSubscriptionExpired || isLocked) return null

	return (
		<div
			className="shrink-0 border-b border-amber-200 bg-amber-50 px-4 py-2 text-center text-sm text-amber-900"
			role="alert"
		>
			Your subscription has ended. Please renew or contact your financial administrator or{' '}
			<a
				href="mailto:support@modelmatic.nl"
				className="font-medium underline underline-offset-2 hover:text-amber-700"
			>
				support@modelmatic.nl
			</a>
			.
		</div>
	)
}
